import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "predictive-search-result-product",
  class PredictiveSearchResultProduct extends WYATTElement {
    constructor() {
      super();

      this.data = JSON.parse(this.dataset.result);

      this.innerHTML = `
        <product-summary 
          data-tabindex="-1" 
          data-handle="${this.data.handle}" 
          data-class-list="product-summary--horizontal product-summary--horizontal-until-medium"
        ></product-summary>
      `;

      this.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick() {
      if (WYATT.config.searchspring.beaconV2Enabled && WYATT.beacon) {
        const surface = WYATT.beacon.detectSurface(this);
        if (surface) {
          WYATT.beacon[surface].clickThrough({
            responseId: WYATT.beacon.getResponseId(this),
            results: [WYATT.beacon.normalizeResult(this.data)],
          });
        }
      }

      if (
        !WYATT.config.searchspring.legacyTrackingEnabled ||
        typeof IntelliSuggest === "undefined" ||
        !this.data.intellisuggestData ||
        !this.data.intellisuggestSignature
      ) {
        return;
      }

      IntelliSuggest.clickItem(this, {
        siteId: WYATT.config.searchspring.siteIds.products,
        intellisuggestData: this.data.intellisuggestData,
        intellisuggestSignature: this.data.intellisuggestSignature,
      });
    }
  },
);
